import axios from 'axios';
import authService from '../services/authService';

// IMPORTANT: Replace with your actual backend URL
const API_URL = 'https://api.lawfullingo.com/api';

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor to add the auth token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // If the request was successful, just return the response
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401)) {
      
      authService.logout();
      
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;